// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Thumbnail_wrapper__2veIu","loading":"Thumbnail_loading__2clYs","name":"Thumbnail_name__fIGjD","text":"Thumbnail_text__8KLli"};